export default function DateDisplay({ day }: { day: string }) {
  const titleDate = new Date(day).toLocaleDateString('en-GB', {
    weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
  const [dayOfWeek, dayOfMonth, month, year] = titleDate.split(' ')
  return (
    <div className="block w-20 overflow-hidden rounded-t bg-white text-center">
      <div className="bg-gray-400 py-1 text-sm leading-none text-white">
        {dayOfWeek}
      </div>
      <div className="border-l border-r pt-1">
        <span className="text-2xl font-bold">{dayOfMonth}</span>
      </div>
      <div className="flex justify-between rounded-b border-b border-l border-r bg-gray-400 px-1 py-1">
        <span className="text-xs font-bold text-white">{month}</span>
        <span className="text-xs font-bold text-white">{year}</span>
      </div>
    </div>
  )
}
